import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { preloadCriticalResources, performanceMonitor } from './utils/performance';

// 预加载关键资源
preloadCriticalResources();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// 性能监控
performanceMonitor.measureLCP((lcp) => {
  console.log('LCP:', lcp);
});

performanceMonitor.measureFID((fid) => {
  console.log('FID:', fid);
});

performanceMonitor.measureCLS((cls) => {
  console.log('CLS:', cls);
});

// 注册 Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
